<template>
    <div class="modal-card card">
        <div class="pt-3">
            <div class="is-size-5 has-text-weight-semibold has-text-centered">แก้ไขสถาที่ปลายทาง</div>
            <div class="is-size-7 has-text-weight-light	 has-text-centered">*ลากเพื่อแก้ไขสถานที่ปลายทาง*</div>
        </div>
        <section>
            <b-field
                horizontal
                label="ค้นหาสถานที่"
                class="py-3"
            >
                <b-dropdown
                    :triggers="['focus','hover']"
                    aria-role="list"
                    expanded
                    class="pr-3"
                >
                    <template #trigger>
                        <input
                            class="input"
                            v-debounce="750"
                            v-model.lazy="text"
                        />
                    </template>
                    <b-dropdown-item
                        aria-role="listitem"
                        v-for="(address, index) in predictList"
                        :key="index"
                        @click="selectedIndex = index"
                        :active="index == selectedIndex"
                    >{{ address.description }}</b-dropdown-item>
                </b-dropdown>
            </b-field>
        </section>
        <section>
            <div
                ref="mapp"
                style="width:100%;height:400px;margin:auto"
            >
            </div>
            <b-field
                class="px-3 py-1"
                label="ที่อยู่ที่เลือก"
            >
                {{finalAddress.text}}
            </b-field>
            <b-field
                class="px-3 py-1"
                label="Latitude Longitude Coordinates"
            >
                lat: {{finalAddress.latlng.lat ? finalAddress.latlng.lat : '' }},
                lng: {{finalAddress.latlng.lng ? finalAddress.latlng.lng : ''}}
            </b-field>
        </section>
        <footer class="modal-card-foot py-3">
            <b-button
                class="column is-6"
                type="is-danger"
                outlined
                expanded
                @click="onClickClose"
            >Cancel</b-button>
            <b-button
                class="column is-6"
                type="is-success"
                outlined
                expanded
                @click="onClickConfirm"
            >Confirm</b-button>
        </footer>
    </div>
</template>

<script>
// import { Loader } from "google-maps";
import debounce from "v-debounce/index";

export default {
  name: "EditMap",
  props: ["initLocation", "initLocationLatLng"],
  data() {
    return {
      map: null,
      text: null,
      zoom: 15,
      google: null,
      predictList: [],
      selectedIndex: -1,
      mapCenter: { lat: 13.732087, lng: 100.567631 },
      mapMarker: null,
      markerPostion: { lat: null, lng: null },
      finalAddress: { text: "", latlng: { lat: null, lng: null } },
    };
  },
  mounted() {
    if (this.initLocationLatLng) {
      this.mapCenter = this.initLocationLatLng;
    }
    console.log("initLocation >>>", this.initLocation);
    console.log("initLocation >>>", this.mapCenter);
    this.initMap();
  },
  watch: {
    zoom: {
      handler(val) {
        val;
        this.initMap();
      },
    },
    text: {
      handler(val) {
        this.mapPlaceSearch(val);
      },
    },
    selectedIndex: {
      handler(val) {
        console.log("selectIndex >>>", this.predictList[val]);
        this.getPlaceDetail(this.predictList[val]);
        this.predictList = [];
      },
    },
  },
  directives: {
    debounce,
  },
  methods: {
    onClickConfirm() {
      console.log("onConfirm >>>", this.finalAddress);
      if (
        (this.finalAddress.text == "") &
        (this.finalAddress.latlng.lat == null) &
        (this.finalAddress.latlng.lng == null)
      ) {
        this.$buefy.toast.open({
          duration: 2000,
          message: `Address Not Found`,
          type: "is-danger",
        });
      } else {
        this.$emit("onConfirm", this.finalAddress);
        this.$emit("close");
      }
    },
    onClickClose() {
      this.$emit("close");
    },
    async getGeoCode() {
      const _google = this.google;
      const geocode = new _google.maps.Geocoder();
      const request = {
        location: this.markerPostion,
        // fields: ["address_components", "geometry", "formatted_address"],
      };
      const { results } = await geocode.geocode(request);
      const list = results.filter((i) => i.geometry.location_type === "ROOFTOP");
      const final = list[0];
      const _addressLocation = {
        lat: final.geometry.location.lat(),
        lng: final.geometry.location.lng(),
      };
      console.log("Geocode >>>", final);
      this.finalAddress = {
        text: final.formatted_address,
        latlng: _addressLocation,
      };
      this.text = null;
      this.updateMapMarker();
    },
    mapInteract() {
      this.markerPostion.lat = this.mapMarker.getPosition().lat();
      this.markerPostion.lng = this.mapMarker.getPosition().lng();
      console.log("poition >>>", this.markerPostion);
      // this.mapCenter = this.markerPostion;
      // this.drawMap();
      this.getGeoCode();
    },
    async initMap() {
      // const loader = new Loader();
      // this.google = await loader.load();
      this.google = window.google;
      //   console.log("google init >>>>", this.google);
      this.drawMap();
    },
    updateMapMarker() {
      this.mapMarker.setMap(this.map);
      this.mapMarker.setPosition(this.finalAddress.latlng);
    },
    setMapMarker() {
      const _google = this.google;
      this.mapMarker = new _google.maps.Marker({
        draggable: true,
        map: this.map,
        position: this.mapCenter,
      });
      this.mapMarker.addListener("dragend", () => {
        this.mapInteract();
      });
      // this.mapMarker.setDraggable(true);
      // this.mapMarker.setMap(this.map);
      // this.mapMarker.setPosition(this.mapCenter);
    },
    async drawMap() {
      const _google = this.google;
      this.map = new _google.maps.Map(this.$refs.mapp, {
        center: this.mapCenter,
        zoom: this.zoom,
      });
      this.setMapMarker();
    },
    async updateDrawMap() {
      return;
    },
    async getPlaceDetail(address) {
      const _google = this.google;
      const service = new _google.maps.places.PlacesService(this.$refs.mapp);
      const request = {
        placeId: address.place_id,
        fields: ["address_components", "geometry", "formatted_address"],
      };

      await service.getDetails(request, (result, status) => {
        status;
        const _addressLocation = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
        };
        this.mapCenter = {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
        };
        console.log("getDetails:", result, _addressLocation, this.mapCenter);
        this.finalAddress = {
          text: result.formatted_address,
          latlng: _addressLocation,
        };
        this.drawMap();
      });
    },
    async mapPlaceSearch(keyword) {
      if (keyword === null) {
        this.predictList = [];
        return;
      }
      if (keyword === undefined) {
        this.predictList = [];
        return;
      }
      if (keyword === "") {
        this.predictList = [];
        return;
      }
      //   console.log("google >>>>", this.google);
      console.log("place >>>>", keyword);
      const _google = this.google;
      const places = new _google.maps.places.AutocompleteService();
      places.getQueryPredictions(
        {
          input: keyword,
          location: new _google.maps.LatLng(13.736717, 100.523186),
          radius: 550000,
        },
        (predictions, status) => {
          status;
          console.log("Query result: ", predictions);
          if (predictions) {
            predictions.forEach((item) => console.log(item.description));
            this.predictList = predictions;
          }
        }
      );
    },
  },
};
</script>

<style>
.modal-card {
  overflow-y: initial !important;
}
</style>